import { APIS } from "../../components/constants/app.constant";
import { getResource, putResource } from "../axiosService";

interface ESign{
    signature_text : string,
    agree: boolean
}
export function updateSign(data: ESign, uuid : string){
    const apiUrl = APIS.SIGN.replace('{uuid}', uuid);
    return putResource(apiUrl, data);
}
export function getPdfDocument(uuid : string){
    const apiUrl = APIS.GET_PDF.replace('{uuid}', uuid);
    return getResource(apiUrl);
}
export function invalidateEmployeeToken(){
    const apiUrl = APIS.INVALIDATE_TOKEN;
    return getResource(apiUrl);
}